import { render, staticRenderFns } from "./CreateTagModal.vue?vue&type=template&id=57f1b3cd&scoped=true"
import script from "./CreateTagModal.vue?vue&type=script&lang=js"
export * from "./CreateTagModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTagModal.vue?vue&type=style&index=0&id=57f1b3cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f1b3cd",
  null
  
)

export default component.exports